import React from "react";
import { useTranslation } from "react-i18next";
import { ANALYSIS } from "@/constants/testIds";

// Linear metric card with animated bar
export default function MetricCard({ title, value = 0, unit = "/100", detail, feedback, tone }) {
  const { t } = useTranslation();
  const clamped = Math.max(0, Math.min(100, value));
  const color =
    tone === "hit"
      ? "var(--meter-hit)"
      : tone === "dance"
        ? "var(--meter-dance)"
        : clamped >= 75
          ? "var(--meter-excellent)"
          : clamped >= 50
            ? "var(--meter-good)"
            : "var(--meter-poor)";

  return (
    <div className="card p-5 flex flex-col gap-3 relative" data-testid={ANALYSIS.metricCard}>
      <div className="flex items-start justify-between">
        <div>
          <div className="tiny-caps">{title}</div>
          <div className="flex items-baseline gap-1 mt-1">
            <span className="metric-value text-3xl text-white">{Math.round(clamped)}</span>
            <span className="text-sm text-[color:var(--fg-muted)] metric-value">{unit}</span>
          </div>
        </div>
        {detail && (
          <div className="text-right">
            <div className="tiny-caps text-[10px] opacity-60">{t("analysis.measured")}</div>
            <div className="metric-value text-sm text-[color:var(--fg-secondary)] mt-0.5">{detail}</div>
          </div>
        )}
      </div>
      <div className="h-1.5 rounded-full bg-white/5 overflow-hidden">
        <div
          className="h-full rounded-full"
          style={{
            width: `${clamped}%`,
            background: color,
            transition: "width 1s cubic-bezier(0.2,0.7,0.2,1)",
          }}
        />
      </div>
      {feedback && (
        <div className="text-[13px] leading-relaxed text-[color:var(--fg-secondary)] pt-1 border-t border-white/5 mt-1">
          {feedback}
        </div>
      )}
    </div>
  );
}
